import Component from "../../lib/Component.js";
import { loadLunrSearch } from "../helpers.js";
import ScrollInView from "./ScrollInView.js";
import MovieList from "./MovieList.js";

const SimilarMovies = (container) => {
  if (!container) {
    return Component.noop();
  }

  const movieListEl = container.querySelector(".similar-movies");
  const messageEl = null; // No message element needed for similar movies

  return ScrollInView({
    componentName: "SimilarMovies",
    observables: [container],
    disconnectOnFirst: true,
    onEnter: async () => {
      // Extract movie slug from container
      const currentMovieSlug = container.dataset.movieSlug;

      if (!currentMovieSlug) {
        container.style.display = "none";
        return;
      }

      // Initialize MovieList component
      const movieList = MovieList(movieListEl, messageEl, {
        inverse: false,
        selectable: false,
      });
      movieList.mount();

      try {
        // Load LunrSearch with recommendation mode enabled
        const lunrSearch = await loadLunrSearch({
          recommendationMode: true,
        });

        // Get the reference movie from the index (original, unformatted version)
        const referenceMovie = lunrSearch.getOriginalDocumentByRef(currentMovieSlug);
        if (!referenceMovie) {
          if (process.env.NODE_ENV === "development")
            console.error("SimilarMovies: Reference movie not found in index:", currentMovieSlug);
          container.style.display = "none";
          return;
        }

        // Search for similar movies (get 6 to account for filtering out the reference movie)
        const similarMovies = lunrSearch.searchSimilar(
          {
            id: currentMovieSlug, // Use full slug as the document ID
            genres: referenceMovie.genres, // Use genres from the index, not from template
            hu_title: referenceMovie.hu_title,
            year: referenceMovie.year,
          },
          6
        );

        // Filter out the reference movie itself and limit to 5
        const filteredMovies = similarMovies.filter((match) => match.ref !== currentMovieSlug).slice(0, 5);

        // Render similar movies using MovieList
        if (filteredMovies.length > 0) {
          filteredMovies.forEach((match) => {
            const doc = lunrSearch.getDocumentByRef(match.ref);
            movieList.addMovie({
              id: doc.id,
              slug: doc.slug,
              delayed: doc.delayed,
              soon: doc.soon,
              poster: doc.generated_poster_thumb,
              distributor: doc.distributor,
              release_date: doc.hu_release_nice,
              title: doc.hu_title,
              subtitle: doc.subtitle,
              age_limit: doc.age_limit,
              original_title: doc.title,
              year: doc.year,
              top_country: doc.top_country,
              genres: doc.genres,
              runtime: doc.runtime || 90,
            });
          });
        } else {
          // Hide the section if no similar movies found
          container.style.display = "none";
        }
      } catch (error) {
        if (process.env.NODE_ENV === "development") console.error("Failed to load similar movies:", error);
        container.style.display = "none";
      }
    },
  });
};

export default SimilarMovies;
